const FALLBACK_COUNTRY_NAMES: Record<string, string> = {
  GB: 'United Kingdom',
  UK: 'United Kingdom',
  US: 'United States',
}

export const normalizeCountryIsoCode = (
  countryIsoCode: string | null | undefined
) => {
  const code = countryIsoCode?.trim().toUpperCase()
  if (!code) return null
  return code === 'UK' ? 'GB' : code
}

export const getCountryDisplayName = (
  countryIsoCode: string | null | undefined,
  locale = 'en-GB'
) => {
  const normalizedCode = normalizeCountryIsoCode(countryIsoCode)
  if (!normalizedCode) return null

  try {
    return (
      new Intl.DisplayNames([locale], { type: 'region' }).of(normalizedCode) ||
      FALLBACK_COUNTRY_NAMES[normalizedCode] ||
      normalizedCode
    )
  } catch {
    return FALLBACK_COUNTRY_NAMES[normalizedCode] || normalizedCode
  }
}
